/**
 * Class estática responsável por armazenar as strings de eventos.
 */
export class AutenticationEventType {
	/**
	 * Constante de eventos do login
	 */
	static LOGIN = {
		LOGIN: 'LOGIN',
		UPDATE_BOX: 'UPDATE_BOX',
		DEFINE_PASSWORD: 'DEFINE_PASSWORD',
		REDEFINE_PASSWORD: 'REDEFINE_PASSWORD',
		DEFINE_SUBSCRIBE: 'DEFINE_SUBSCRIBE',
		LOST_MY_PASS: 'LOST_MY_PASS',
		USER_AND_PASS: 'USER_AND_PASS',
		MY_CPF: 'MY_CPF',
		CREATE_PASS_SUCCESS: 'CREATE_PASS_SUCCESS',
		ACCOUNTS_LIST: 'ACCOUNTS_LIST',
		PASS_MONITOR: 'PASS_MONITOR',
		PASS_MONITOR_BLOCKED: 'PASS_MONITOR_BLOCKED',
		SECURITY_CHECK: 'AUTH_SECURITY_CHECK',
		RESET_LOGIN: 'RESET_LOGIN',
		LOADER: 'LOADER',
		AUTH_MESSAGE: 'AUTH_MESSAGE',
		TOKEN_VALIDATION: 'TOKEN_VALIDATION',
		SMS_VALIDATION: 'SMS_VALIDATION',
		VERIFY_TERMS: 	'VERIFY_TERMS',
		BLOCK_LOADER: 'BLOCK_LOADER'
	};

	static SECURITY_CHECK_REGISTRATION = {
		INIT: 'INIT',
		INFO: 'INFO',
		REGISTRATION: 'REGISTRATION'
	};
	static ATTENDANT = {
		ATTENDANT_AUTH: 'ATTENDANT_AUTH'
	};

	static DEFINE_SUBSCRIBE = {
		FIRSTACCESS: 'FIRSTACCESS'
	};

	static ACCOUNT = {
		CHANGE_ACCOUNT: 'CHANGE_ACCOUNT',
		CHANGE_ACCOUNT_MENU: 'CHANGE_ACCOUNT_MENU'
	};

	static AUTH_MESSAGE = {
		'LOAD_COMPLETE': 'AUTH_MESSAGE_LOAD_COMPLETE'
	};

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/autentication.event.type.ts